import {create} from 'zustand'
import {persist} from 'zustand/middleware'
import {IResDataToFrom} from '../helpers'

interface IDispatches {
  dipatches: IInputMutation[]
  isSending: boolean
  totalDispatches: number

  inc: (inp: IInputMutation) => void
  toggleSending: (bool: boolean) => void
  updateTotalDispatches: (tot: number) => void
  removeDispatch: (info: {uuid: any}) => void
}

export interface IInputMutation {
  sale: number
  client: string
  quarry: number
  // product: string
  products: {quantityDispatch: number; product: string}[]
  departureTime: string
  uuid: any
  plate: string
  // quantityDispatch: string
  observations: string
  delivery?: {
    date: string
    totalTravel: string
    fromLocation: string
    untilLocation: string
    responsible: string
  }
  form?: {
    forms: IResDataToFrom[]
  }
}

export const useDispatchesStore = create<IDispatches>()(
  persist(
    (set, get) => ({
      dipatches: [],
      isSending: false,
      totalDispatches: 0,
      inc: (inp) => set((state) => ({dipatches: [...state.dipatches, inp]})),
      toggleSending: (bool) => set(() => ({isSending: bool})),
      updateTotalDispatches: (tot) => set(() => ({totalDispatches: tot})),
      removeDispatch: ({uuid}) => {
        const {dipatches: prevDisp} = get()
        const filtered = prevDisp.filter(({uuid: preUuid}) => preUuid !== uuid)
        return set(() => ({dipatches: filtered}))
      },
    }),
    {name: 'store'}
  )
)
